import React from "react";
import styles from "./page3.module.scss";
import c from "../../icons/c.svg";
import phython from "../../icons/phython.svg";
import node from "../../icons/nodejs.svg";

export default function Page3() {
  return (
    <div className={styles.mainwrapper}>
      <div>
        <p className={styles.heading}>Generate SDKs in 3 languages</p>
      </div>
      <div className={styles.mainbox}>
        <div className={styles.box}>
          <img className={styles.c} src={c} alt="c" />

          <p style={{ fontSize: "15px", fontWeight: 500, marginTop: "10px" }}>C#</p>
        </div>
        <div className={styles.box}>
          <img className={styles.phython} src={phython} alt="c" />

          <p style={{ fontSize: "15px", fontWeight: 500, marginTop: "10px" }}>
            Python
          </p>
        </div>
        <div className={styles.box}>
          <img className={styles.node} src={node} alt="node" />

          <p style={{ fontSize: "15px", fontWeight: 500, marginTop: "10px" }}>Node.js</p>
        </div>
      </div>
    </div>
  );
}
